import React, { useState } from "react";
import axios from "axios";
import "./Settings.css";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL;
const API = `${API_BASE_URL}/api/user` ;

function Settings() {
  const token = localStorage.getItem("token");

  const [notifications, setNotifications] = useState(true);
  const [marketingEmails, setMarketingEmails] = useState(false);
  const [loading, setLoading] = useState(false);

  const saveSettings = async () => {
    try {
      setLoading(true);

      await axios.put(
        `${API}/settings`,
        {
          notifications,
          marketingEmails,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      alert("Settings updated successfully.");
    } catch (err) {
      console.log(err);
      alert("Unable to update settings.");
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    localStorage.removeItem("token");
    window.location.href = "/login";
  };

  const deleteAccount = async () => {
    const confirmDelete = window.confirm(
      "Are you sure you want to permanently delete your account?"
    );

    if (!confirmDelete) return;

    try {
      await axios.delete(`${API}/account`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      localStorage.removeItem("token");
      window.location.href = "/";
    } catch (err) {
      console.log(err);
      alert("Unable to delete account.");
    }
  };

  return (
    <div className="settings-page">
      <div className="settings-shell">
        <div className="settings-header">
          <div>
            <span className="settings-tag">Manage Account</span>
            <h2>Account Settings</h2>
            <p>
              Update your preferences, control notifications, and manage account
              access.
            </p>
          </div>

          <button
            className="theme-btn settings-save-top"
            disabled={loading}
            onClick={saveSettings}
          >
            {loading ? "Saving..." : "Save Changes"}
          </button>
        </div>

        <div className="settings-grid">
          <div className="setting-card">
            <div className="setting-card-head">
              <div>
                <h3>Notifications</h3>
                <p>Control how you receive order and account activity updates.</p>
              </div>
              <div className="setting-icon">🔔</div>
            </div>

            <div className="setting-row">
              <div>
                <h4>Push Notifications</h4>
                <span>Receive important account and order alerts.</span>
              </div>

              <label className="switch">
                <input
                  type="checkbox"
                  checked={notifications}
                  onChange={() => setNotifications(!notifications)}
                />
                <span className="slider"></span>
              </label>
            </div>
          </div>

          <div className="setting-card">
            <div className="setting-card-head">
              <div>
                <h3>Marketing Emails</h3>
                <p>Choose whether you want offers, product updates, and newsletters.</p>
              </div>
              <div className="setting-icon">✉️</div>
            </div>

            <div className="setting-row">
              <div>
                <h4>Promotions & Updates</h4>
                <span>Get discounts, offers, and new feature announcements.</span>
              </div>

              <label className="switch">
                <input
                  type="checkbox"
                  checked={marketingEmails}
                  onChange={() => setMarketingEmails(!marketingEmails)}
                />
                <span className="slider"></span>
              </label>
            </div>
          </div>

          <div className="setting-card action-card">
            <div className="setting-card-head">
              <div>
                <h3>Logout</h3>
                <p>End your current session on this device securely.</p>
              </div>
              <div className="setting-icon">↗</div>
            </div>

            <button className="outline-btn" onClick={logout}>
              Logout
            </button>
          </div>
{/* 
          <div className="setting-card delete-card">
            <div className="setting-card-head">
              <div>
                <h3>Delete Account</h3>
                <p>
                  Permanently remove your account and all associated data. This
                  action cannot be undone.
                </p>
              </div>
              <div className="setting-icon danger-icon">!</div>
            </div>

            <button className="danger-btn" onClick={deleteAccount}>
              Delete Account
            </button>
          </div> */}
        </div>

        <div className="settings-footer">
          <p>Your changes will be applied to this account after saving.</p>

          <button
            className="theme-btn"
            disabled={loading}
            onClick={saveSettings}
          >
            {loading ? "Saving..." : "Save Settings"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default Settings;